import {FormSectionType} from '../../../../blocks/FormBlock'
import box from '../../../../webshop/pages/cart/orderform/fields/box'
import city from '../../../../webshop/pages/cart/orderform/fields/city'
import {copy} from '../../../../../util/fieldscopy'
import houseNumber from '../../../../webshop/pages/cart/orderform/fields/houseNumber'
import street from '../../../../webshop/pages/cart/orderform/fields/street'
import zip from '../../../../webshop/pages/cart/orderform/fields/zip'

const sectionId: number = 2
const addressInfoSection: FormSectionType = {
	id: sectionId,
	parent_id: 0,
	channel: 'section',
	label: copy?.address_details || 'Adresgegevens',
	fields: [
		{...street, id: 1, parent_id: sectionId},
		{...houseNumber, id: 2, parent_id: sectionId},
		{...box, id: 3, parent_id: sectionId},
		{...zip, id: 4, parent_id: sectionId},
		{...city, id: 5, parent_id: sectionId}
	]
}

export default addressInfoSection
